import {NavLink, NavLinkProps} from "react-router-dom";
import React from "react";
import {ChevronRightIcon} from "@components/Icons/ChevronRightIcon";
import ResponsivePicture from "@components/ResponsivePicture/ResponsivePicture";
import {useProjectTranslations} from "@i18n/i18nUtils";
import {formatPoints} from "@commons/Utils";

export interface ProductCardProps {
    image?: string;
    categoryName?: string|null;
    title: string;
    points: number;
    linkProps: NavLinkProps;
}

const ProductCard = ({image, categoryName, title, points, linkProps}: ProductCardProps) => {

    const {t} = useProjectTranslations();

    return (
        <div className="card product">
            <div className="card__hero">
                {!!image &&
                    <ResponsivePicture images={[image]} cover/>
                }
            </div>
            <div className="card__content">
                <div className="card__header">
                    <div className="card__meta">
                        <span className={"tp-xs color-primary"}>{categoryName}</span>
                    </div>
                    <h3 className={"tp-xs semibold"}>{title}</h3>
                    <p className="card__price">
                        <span className={"tp-l color-primary bold"}>{formatPoints(points)}</span>
                        <span className={"tp-xs color-primary light"}>{t("points", {count: points})}</span>
                    </p>
                </div>
                <div className="card__actions">
                    <NavLink {...linkProps} className={"tp-xs color-primary semibold card__cta"}>
                        <span className={"label"}>{t("cta:products:discover")}</span>
                        <span className={"icon"}>
                            <ChevronRightIcon/>
                        </span>
                    </NavLink>
                </div>
            </div>
        </div>

    );

}

export default ProductCard;